import { deepClone } from "@/utils/tool";
function initAttrs() {
  return {
    marketPrice: "", //市场价
    mercSettPrice: "", //单家结算价
    salesNum: "", //售卖价格
    sellingPrice: "", //售卖价格
    outSkuId: "", //外部商品id
    specCode: "", //商品码
    stock: "", //库存
    shelfMark: 2, //1上架 2下架
    __SkuSelected: "", //是否为APP生成的商品
    priceRate: 0,
  };
}

const goods = {
  namespaced: true,
  state: {
    SpecListCache: [], //规格产品缓存
    SpecList: [], //规格产品
    AttrList: [
      {
        attrName: "自定义属性",
        attrId: "",
        children: [
          {
            attrName: "自定义属性",
            attrValue: "",
            parentId: "",
          },
        ],
      },
    ], //属性列表
    Goods: {}, //商品属性
  },
  getters: {
    // 商品信息
    goods(state) {
      return state.Goods;
    },
    // 商品SKU列表
    specList(state) {
      return state.SpecList;
    },
    // 商品属性列表
    attrList(state) {
      return state.AttrList;
    },
  },
  mutations: {
    // goods属性更新
    refushGoods (state) {
      state.Goods.attrList = deepClone(state.AttrList); //更新商品信息触发监听
      state.Goods.specList = deepClone(state.SpecList);
    },
    // attrList 覆盖更新
    refushAttrList(state) {
      state.Goods.attrList = deepClone(state.AttrList);
    },
    // specList覆盖更新
    refushSpecList (state) {
      state.Goods.specList = deepClone(state.SpecList);
    },
    // 设置商品数据
    setProduct(state, { product }) {
      state.Goods = product;
    },
    // 存入缓存列表
    setSpecListCache(state, { catchList }) {
      state.SpecListCache = deepClone(catchList);
    },
    // 更新缓存内SKU
    setSpecCacheInfo(state, { Sku }) {
      let inCache = state.SpecListCache.findIndex(
        (val) => val.__SkuPath == Sku.__SkuPath
      );
      inCache >= 0
        ? (state.SpecListCache[inCache] = Sku)
        : state.SpecListCache.push(Sku);
    },
    // 存入商品属性
    setAttrList(state, { attrList }) {
      state.AttrList = deepClone(attrList);
    },
    // 保存sku列表
    setSpecList (state, { list }) {
      list.forEach((item) => {
        let obj = state.SpecList.find(itemS => item.__SkuPath == itemS.__SkuPath)
        item = Object.assign(item, obj)
        item.__SkuSelected = false;
        let inCache = state.SpecListCache.findIndex(
          (val) => val.__SkuPath == item.__SkuPath
        );
        if (inCache >= 0) {
          let cache = state.SpecListCache[inCache];
          let object = initAttrs();
          for (const key in object) {
            if (Object.hasOwnProperty.call(cache, key)) item[key] = cache[key];
          }
          item.__SkuSelected = cache.__SkuSelected;
        } else {
          state.SpecListCache.push(item);
        }
      });
      // 排序
      list.sort((a, b) => {
        return a.shelfMark - b.shelfMark;
      });
      state.SpecList = deepClone(list);
    },
    // 更新SKU列表中的attr属性
    setSpecListAttr(state, { x, y, attrName, oldAttrValue, attrValue }) {
      state.SpecList.forEach((item) => {
        //attrName:更新的一级属性值 attrValue:更新的二级属性值  oldAttrValue:最开始的二级属性值
        if (attrValue) {
          if (item.attr[x].attrValue == oldAttrValue) {
            item.attr[x].attrValue = attrValue;
            item.__SkuPath = "";
            item.attr.forEach((val) => {
              item.__SkuPath += val.attrName + "." + val.attrValue + "_";
            });
          }
        } else {
          if (item.attr[x]) {
            item.attr[x].attrName = attrName;
            item.__SkuPath = "";
            item.attr.forEach((val) => {
              item.__SkuPath += val.attrName + "." + val.attrValue + "_";
            });
          }
        }
      });
    },
  },
};

export default goods;
